import { BoundingBox, MapSearchSuggestion } from '@bpd-library/types';

interface CityAlternative {
    query: string;
    title: string;
    bbox: BoundingBox;
}

const ALTERNATIVES: CityAlternative[] = [
    {
        query: 'Den Bosch',
        title: 'Den Bosch, Noord-Brabant, Nederland',
        bbox: [5.206494, 51.663997, 5.377136, 51.755477],
    },
    {
        query: "'s-Gravenhage",
        title: "'s-Gravenhage, Zuid-Holland, Nederland",
        bbox: [4.1962, 52.014848, 4.42249, 52.128324],
    },
];

function getCityAlternativeSuggestions(searchQuery: string): MapSearchSuggestion[] {
    const suggestions: MapSearchSuggestion[] = [];

    ALTERNATIVES.forEach(({ title, query, bbox }) => {
        if (query.toLowerCase().indexOf(searchQuery) > -1) {
            suggestions.push({
                title,
                bbox,
            });
        }
    });

    return suggestions;
}

export default getCityAlternativeSuggestions;
